import { useQuery } from "@tanstack/react-query";
import { getServicesHealth } from "@/services/management";
import type { ServiceStatus } from "@/features/downloads/types";

export const serviceKeys = {
  all: ["services"] as const,
  health: () => [...serviceKeys.all, "health"] as const,
};

export function useServicesHealth() {
  return useQuery<ServiceStatus[]>({
    queryKey: serviceKeys.health(),
    queryFn: () => getServicesHealth(),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
